import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, Button, message, Drawer } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon, langPage } from "../../../locales";
import { SettingsServer } from "../../../server";
import { generateOperationFormConfig, DEFAULT_OPERATION_FORM_DATA } from './config'

const server = SettingsServer.Notice;
const lang = langPage?.settings.notice;

type OperateModeType = 'create' | 'modify'


export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_FORM_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('create');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_FORM_DATA,
                ...(mode === 'modify' ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(mode === 'create' ? server.create : server.modify, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(mode === 'create' ? langCommon?.createSuccess : langCommon?.modifySuccess);
            changeVisible(false);
            onSuccess?.();
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return generateOperationFormConfig({ formData, mode, setFormData });
    }, [formData, mode, setFormData]);

    const handleSubmitData = async () => {
        await form.validateFields()
        run(formData)
    }


    const renderFooter = () => {
        return (
            <div className='flex align-center space-between'>
                <Button onClick={() => changeVisible(false)} >{langCommon?.cancel}</Button>
                <div className='txtr'>
                    <Button type='primary' loading={loading} onClick={() => handleSubmitData()} >{langCommon?.confirm}</Button>
                </div >
            </div>
        );
    }

    return (
        <div>
            <Drawer
                title={`${mode === 'create' ? langCommon?.create : langCommon?.modify}${lang?.noticeS}`}
                width={window?.innerWidth > 1500 ? '70%' : 1000}
                closeIcon={null}
                open={visible}
                footer={renderFooter()}
                onClose={() => changeVisible(false)}
            >
                <EditForm
                    componentId="notice-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                    openDebounce={400}
                />
            </Drawer>
        </div>
    );
})
